module.exports = __webpack_public_path__ + "static/media/electromovilidad vehiculos comerciales 60.5b2c9d87.jpg";